import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilOutlineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.1 19q-.8.8-1 1.9l-1.9 6.4q-.1.6.4 1.2.5.4 1.1.3l6.4-1.8q1-.3 2-1.1l14.7-14.7a3.6 3.6 0 0 0 0-5.2L26 4.3a3.6 3.6 0 0 0-5.2 0zM23.4 5.6q.5 0 .9.4L26 7.7q.4.5.4.9t-.4.9L23.4 12l-3.5-3.5L22.5 6q.4-.4.9-.4M8.7 19.8l9.5-9.5 3.5 3.5-9.5 9.5zm-1.4 2 3 3-4.2 1z" })
});
export default SvgPencilOutlineIcon;
